import { Star } from 'lucide-react';

// Small shared star-rating renderer used by both review tabs.
const RatingStars = ({ rating = 0, size = 14 }) => {
    const value = Number(rating) || 0;
    return (
        <div className="flex items-center gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
                <Star
                    key={i}
                    size={size}
                    className={i < value ? 'fill-amber-400 text-amber-400' : 'text-gray-300'}
                />
            ))}
        </div>
    );
};

export default RatingStars;
